<template>
  <div>
    <BaseHeading
      :semantic-level="3"
      color="turquoise"
      :class="$style.spacingTop"
    >
      <BaseIcon :icon="icon" />
      {{ title }}
    </BaseHeading>
    <div :class="$style.block" v-bind="$attrs">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseHeading from '~/base/components/heading/Heading.vue'
import BaseIcon from '~/base/components/icon/Icon.vue'

    interface SummaryBlockProps {
    icon?: 'iconCal' | 'iconUser' | 'iconWench'
    title: string
    }

defineProps<SummaryBlockProps>()
</script>

<style module>
.block {
  padding: 8px 12px 8px 28px;
  p {
    margin-top: var(--space-xxs);
  }
}

.spacingTop {
  margin-top: var(--space-md);
}
</style>
